<template>
    <div class="login-box">

        <div class="image-box">
            <img src="./../assets/images/logo-black.svg" alt="Spillard logo" />
        </div>

        <div class="login-form form">
            <h2>Change your password</h2>

            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
            >
                <v-layout row>
                    <v-flex xs4>
                        <div class="error-block" v-if="errors">
                            <p v-html="errors" class="no-margin"></p>
                        </div>
                        <div class="label-box">
                            <div class="label text-xs-right">
                                <span class="text-xs-right"> Password <span class="required">*</span></span>
                            </div>
                        </div>
                    </v-flex>
                    <v-flex xs8>
                        <div class="input-box">
                            <v-text-field
                                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                :type="showPassword ? 'text' : 'password'"
                                :rules="rules.password"
                                label="Password"
                                required
                                outline
                                single-line
                                v-model="form.password"
                                @click:append="showPassword = !showPassword"
                                @keyup="validatePasswords"
                            ></v-text-field>
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex xs4>
                        <div class="error-block" v-if="errors">
                            <p v-html="errors" class="no-margin"></p>
                        </div>
                        <div class="label-box">
                            <div class="label text-xs-right">
                                <span class="text-xs-right"> Repeat Password <span class="required">*</span></span>
                            </div>
                        </div>
                    </v-flex>
                    <v-flex xs8>
                        <div class="input-box">
                            <v-text-field
                                :append-icon="showPasswordRepeat ? 'visibility' : 'visibility_off'"
                                :type="showPasswordRepeat ? 'text' : 'password'"
                                label="Repeat Password"
                                required
                                outline
                                single-line
                                v-model="form.passwordRepeat"
                                @click:append="showPasswordRepeat = !showPasswordRepeat "
                                @keyup="validatePasswords"
                            ></v-text-field>
                        </div>
                    </v-flex>
                </v-layout>

                <div class="buttons">
                    <sp-button
                        @click.native="goToLoginPage"
                        sp-class="primary"
                        text="To Login page"
                    ></sp-button>
                    <sp-button
                        @click.native="changePassword"
                        type="submit"
                        sp-class="primary"
                        text="Change password"
                    ></sp-button>
                </div>
            </v-form>
        </div>
    </div>
</template>

<script>
import SpButton from '@/components/forms/Button'
import router from '@/router/routes'
import { mapActions } from 'vuex'
import toast from '@/plugins/izitoast'
import AccountApi from '@/api/AccountApi'

const body = document.body
const accountApi = new AccountApi()

export default {
    name: 'RestorePassword',
    mounted () {
        this.restoreKey = this.$route.params.restorePasswordKey
        body.classList.add('reset-view')
    },
    beforeDestroy () {
        body.classList.remove('reset-view')
    },
    components: {
        SpButton
    },
    data () {
        return {
            showPassword: false,
            showPasswordRepeat: false,
            valid: false,
            errors: null,
            restoreKey: null,
            form: {
                passwordRepeat: '',
                password: ''
            },
            rules: {
                password: [
                    v => this.validatePassword(v) || 'Password must be between 8 and 15 characters, must contain capital letter, lower case letter and number',
                    v => (v && v.length && v === this.form.passwordRepeat) || 'New password and confirm new password must be the same.'
                ]
            }
        }
    },
    computed: {
    },
    watch: {
    },
    methods: {
        async changePassword (e) {
            e.preventDefault()
            this.valid = this.$refs.form.validate()
            if (!this.valid) return
            const response = await accountApi.activateAccount({
                key: this.restoreKey,
                password: this.form.password
            })

            if (!response.isSuccess) return

            toast.success('Password successfully changed')
            router.push('/')
        },
        validatePasswords () {
            this.valid = this.$refs.form.validate()
        },
        ...mapActions({
            setCredentials: 'authModule/setCredentials',
            clearCredentials: 'authModule/clearCredentials',
            setUserInfo: 'authModule/setUserInfo',
            setDictionaries: 'dictionaryModule/setDictionaries',
            setSignalRConnection: 'signalR/setSignalRConnection',
            clearSignalRConnection: 'signalR/clearSignalRConnection',
        }),
        validatePassword (v) {
            let regex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,15}$)')
            return regex.test(v)
        },
        goToLoginPage () {
            router.push('/')
        }
    }
}
</script>

<style lang="scss">
.reset-view {
    #app {
        background-image: url('./../assets/images/login-background.png');
        background-color: transparent;
        background-size: cover;
    }

    .login-box {
        width: 600px;
        margin: 0 auto;
        position: relative;
        top: 50%;
        transform: translateY(-50%);

        .image-box {
            text-align: center;
            margin-bottom: 30px;
        }

        .login-form {
            background-color: $white;
            padding: 30px 50px;

            h2 {
                text-align: center;
                margin-bottom: 30px;
            }

            .form-group {
                display: block;

                .label-box, .input-box {
                    display: inline-block;
                }

                .label-box {
                    width: 140px;
                }

                .input-box {
                    width: calc(100% - 140px);
                }
            }
        }

        .buttons {
            display: flex;
            justify-content: space-between;
            text-align: center;
        }

        .links {
            margin-top: 20px;
            text-align: center;
            font-size: 14px;

            a {
                color: $dark;
            }
        }

        .v-btn {
            width: 170px;

            .btn {
                width: 100%;

                .text {
                    justify-content: center;
                    width: 100%;
                }
            }
        }
        .resetForm {
            height: 230px;
            overflow: hidden;
            transition:all .2s;
        }
        .resetForm-collapse {
            height:0px;
            opacity: 0;
            overflow:hidden;
        }
        .reset-password-info {
            margin: 30px 0 0 0;
        }
        .btn-forgot {
            font-size: 1rem;
            text-align: center;
            margin: 10px auto 0 auto;
            border: none;
            outline: none;
            display: block;
            width: 170px;
            color: #0067b8;
            &:hover {
                text-decoration: underline;
                color: #1673bb
            }
        }
    }
}
</style>
